import { render, staticRenderFns } from "./VisitrecorderPage.vue?vue&type=template&id=5e2e3f3e&"
import script from "./VisitrecorderPage.vue?vue&type=script&lang=js&"
export * from "./VisitrecorderPage.vue?vue&type=script&lang=js&"
import style0 from "./VisitrecorderPage.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports